// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"c973107a","339":"2d680140","368":"6aae0710","488":"9ab3554e","538":"feb8f3d3","687":"b9b9a617","978":"4f77b55f"}[chunkId] + ".chunk.js";
};